import { Injectable, computed, signal } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class BehaviourService {

  // Inicialización de variables
  private header = signal<boolean>(true);
  public showHeader = computed(() => this.header);

  /**
   * Toggle the value of the signal
   */
  changeStatus(value: boolean) {
    this.header.set(value);
  }
}